/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisibilityConditionOperator } from './VisibilityConditionOperator';
import {
    VisibilityConditionOperatorFromJSON,
    VisibilityConditionOperatorFromJSONTyped,
    VisibilityConditionOperatorToJSON,
    VisibilityConditionOperatorToJSONTyped,
} from './VisibilityConditionOperator';

/**
 * A single leaf condition within a TableRowVisibilityConditionDto's conditions list.
 * @export
 * @interface TableRowVisibilityLeafConditionDto
 */
export interface TableRowVisibilityLeafConditionDto {
    /**
     * Index of the column in the same table to evaluate (0-based)
     * @type {number}
     * @memberof TableRowVisibilityLeafConditionDto
     */
    thisTableColumnIndex?: number;
    /**
     * Condition is met if the source column's value matches any of these with the given operator
     * @type {Array<string>}
     * @memberof TableRowVisibilityLeafConditionDto
     */
    expectedValues?: Array<string>;
    /**
     * 
     * @type {VisibilityConditionOperator}
     * @memberof TableRowVisibilityLeafConditionDto
     */
    operator?: VisibilityConditionOperator;
}



/**
 * Check if a given object implements the TableRowVisibilityLeafConditionDto interface.
 */
export function instanceOfTableRowVisibilityLeafConditionDto(value: object): value is TableRowVisibilityLeafConditionDto {
    return true;
}

export function TableRowVisibilityLeafConditionDtoFromJSON(json: any): TableRowVisibilityLeafConditionDto {
    return TableRowVisibilityLeafConditionDtoFromJSONTyped(json, false);
}

export function TableRowVisibilityLeafConditionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableRowVisibilityLeafConditionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'thisTableColumnIndex': json['thisTableColumnIndex'] == null ? undefined : json['thisTableColumnIndex'],
        'expectedValues': json['expectedValues'] == null ? undefined : json['expectedValues'],
        'operator': json['operator'] == null ? undefined : VisibilityConditionOperatorFromJSON(json['operator']),
    };
}

export function TableRowVisibilityLeafConditionDtoToJSON(json: any): TableRowVisibilityLeafConditionDto {
    return TableRowVisibilityLeafConditionDtoToJSONTyped(json, false);
}

export function TableRowVisibilityLeafConditionDtoToJSONTyped(value?: TableRowVisibilityLeafConditionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'thisTableColumnIndex': value['thisTableColumnIndex'],
        'expectedValues': value['expectedValues'],
        'operator': VisibilityConditionOperatorToJSON(value['operator']),
    };
}

